import type { ComponentType } from 'react';
import type { ExtraRoute } from '@/app/screens';
import { IncomingOffersRedirect } from '@/features/offers/IncomingOffersRedirect';
import { RequestOffersPage } from '@/features/offers/RequestOffersPage';
import { CustomerRequestsPage } from './CustomerRequestsPage';
import { MarketPage } from './MarketPage';
import { MarketTaskDetailPage } from './MarketTaskDetailPage';

/**
 * TALEP EKRANLARI — menu kimligi -> bilesen, + menude gorunmeyen detay rotalari.
 *
 * `src/app/screens.ts` bunlari tek satirla baglar; router'a DOKUNULMAZ
 * (bkz. o dosyanin bas yorumu: bir feature'i hayata gecirmek router.tsx'e
 * dokunmadan mumkun olmali).
 *
 * `exchange.requests` = PIYASA: menu etiketi de ekran basligi da "Piyasa" (K1, 2026-10-02;
 * menu eskiden "Gelen talepler" diyordu). Buro burada acik talepleri gorup teklif veriyor.
 *
 * DETAY ROTALARI menude YER ALMAZ ve bolge guard'ini gruptan MIRAS ALIR:
 *   /musteri/talepler/:taskId -> talep detayi: gelen teklifler (canli) + kazanan secimi
 *   /musteri/teklifler        -> ESKI "Gelen teklifler" adresi; Taleplerim'e yonlendirir
 *                                (ekran 2026-10-02'de kaldirildi, derin baglantilar bozulmasin)
 *   /buro/piyasa/:taskId      -> talep detayi + teklif ver/duzenle
 *
 * Musteri tarafindaki detay rotasinin bileseni `features/offers` icinde yasiyor
 * (icerigi tekliflerdir) ama rota kaydi BURADA: ekstra rotalarin tek bir listede
 * durmasi, hangi adreslerin var oldugunu tek bakista gorunur kiliyor.
 */
export const taskScreens: Readonly<Record<string, ComponentType>> = Object.freeze({
  'customer.requests': CustomerRequestsPage,
  'exchange.requests': MarketPage,
});

export const taskExtraRoutes: Readonly<Record<string, readonly ExtraRoute[]>> = Object.freeze({
  customer: Object.freeze([
    Object.freeze({ path: '/musteri/talepler/:taskId', component: RequestOffersPage }),
    Object.freeze({ path: '/musteri/teklifler', component: IncomingOffersRedirect }),
  ]),
  exchange: Object.freeze([
    // Piyasa detayinin kendisi `viewQuoteRequests` ister; teklif verme yetkisi
    // (createOffer / editOffer) ekranin ICINDE ayrica kontrol edilir — sayfayi
    // gorebilmek ile teklif verebilmek ayni sey degil.
    Object.freeze({
      path: '/buro/piyasa/:taskId',
      component: MarketTaskDetailPage,
      permission: 'viewQuoteRequests' as const,
    }),
  ]),
});
